// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 32 32%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%281, 169, 130, 0.8%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 8h24M4 16h24M4 24h24%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.wrapper {
    max-width: 1600px;
    margin: 0 auto;
    height: 100%;
}

.tab.active {
    font-weight: bold;
}

.page-link {
    color: #01a982;
}

.page-item.active .page-link {
    background-color: #01a982;
    border-color: #01a982;
}

.video-js .vjs-overlay-background {
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 3px;
    padding: 5px;
    width: 33%;
}

.vjs-subs-caps-button .vjs-menu li {
    min-width: 7em;
    width: auto
}

.vjs-menu {
    top: 15px;
    width: auto
}

.vjs-menu li {
    min-width: 7em;
    width: auto
}

.vjs-menu-content {
    overflow-x: hidden;
    height: 100px;
    min-width: 7em;
}

#qa-website-inject {
    max-width: 355px;
    margin: 0 0 0 15px;
}

#qa-website-inject-title {
    display: none;
}

#qa-website-inject-items {
    display: block;
    padding: 15px 0 0 0;
}

img[id^=qa-website-inject-item-image] {
    width: 60px;
    height: 40px;
}

lb-inpage-item {
    display: block;
    padding-left: 20px;
}

div[id^=qa-website-inject-item-title] {
    position: relative;
    bottom: 40px;
    left: 70px;
    width: 240px !important;
    margin: 0 0 0 15px !important;
    color: rgb(51, 51, 51);
    line-height: 20px;
    font-size: 14px;
}

.psn-recommendations-bottom.psn-static-mode .psn-static-title,
.psn-scroll-right,
.psn-scroll-left {
    display: none !important;
}

.psn-recommendations-bottom .psn-item-carousel {
    display: block !important;
    width: 100%;
}

.psn-recommendations-bottom .psn-recommended-item {
    display: block !important;
    margin: 10px 10px !important;
    width: 96% !important;
}

.psn-recommendations-bottom .psn-recommended-item .psn-item-image {
    height: 6em !important;
}

.psn-recommendations-bottom .psn-recommended-item .psn-item-data .psn-item-title span,
.psn-recommendations-bottom .psn-recommended-item .psn-item-data .psn-item-description span.psn-long {
    font-size: 0.80rem !important;
}

.psn-recommendations-bottom .psn-recommended-item .psn-item-data .psn-item-title {
    max-height: 5.00em !important;
}

.psn-item-arrow {
    display: none !important;
}

.pf-item {
    height: 70px;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem;
    margin: 10px;
}

.pf-item a {
    text-decoration: none;
}

.pf-item:hover {
    background: #EDEDED;
}

.productLink {
    font-size: 108%;
    padding: 10px 10px 10px 0;
    display: block;
    height: 60px;
}

.productLink:hover {
    background: #EDEDED;
}

.productLink a {
    padding: 0 10px 0 10px;
    display: block;
}

.productLink span {
    position: relative;
    bottom: 60px;
    left: 80px;
    display: block;
}

.nav-link {
    display: block;
    padding: 0.5rem 0.5rem;
    color: black;
}

.nav-link:hover {
    color: black;
    font-weight: bold;
}

.nav-tabs .nav-link.active {
    color: #01a982;
    font-weight: bold;
}

.card:hover {
    background: #EDEDED;
}

.video-max {
    width: 100%;
    height: 100%;
}

.check-box {
    font-size: 16px;
}

.radio-button {
    font-size: 14px;
}

.vid-container {
    width: 67vw;
    padding-top: 56.25%;
    /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    position: relative;
    /* If you want text inside of it */
}

.bc-player-default_default {
    width: auto;
    height: 100%;
}

.brightcove-react-player-loader {
    width: 100%;
    height: 100%;
}

.tab-box {
    height: 27.5vw !important;
    border-bottom: solid 1px lightgray;
}

.tab-content-container {
    height: 33vw !important;
    overflow-y: auto;
    overflow-x: hidden;
    border-right: solid 1px lightgray;
    border-left: solid 1px lightgray;
    border-bottom: solid 1px lightgray;
}

/* If you want text inside of the container */
.vid-player {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Set the border color */

.custom-toggler.navbar-toggler {
    border-color: #01a982;
    font-size: 0.75rem;
    padding: 0.15rem 0.15rem
}

.custom-toggler .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.navbar {
    padding: 0 1rem;
}

.video-js {
    width: 100%;
    height: 100%;
}

.duration {
    width: 2.5rem;
    height: .75rem;
    position: relative;
    bottom: 0.75rem;
    left: 0.1rem;
    z-index: 1;
    background: #666666;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.vcard-duration {
    width: 2.5rem;
    height: .75rem;
    position: relative;
    top: -1rem;
    right: 0rem;
    z-index: 1;
    background: #666666;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.timeCode {
    font-size: 9px;
    color: #fff;
    position: relative;
    bottom: 0.55rem;
    left: 0.55rem;
}

.podcast {
    width: 2.5rem;
    height: .75rem;
    position: relative;
    top: -3.4rem;
    left: 0.1rem;
    z-index: 1;
    background: #01a982;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.vcard-podcast {
    width: 2.5rem;
    height: .75rem;
    position: relative;
    top: -5.8rem;
    right: 0rem;
    z-index: 1;
    background: #01a982;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.podcast-label {
    font-size: 9px;
    color: #fff;
    position: relative;
    bottom: 0.55rem;
    right: -0.45rem;
}

.search-tab {
    background-color: #01a982 !important;
    color: #FFFFFF !important;
}

/*#root {
    height: 100vh;
}
*/
@media only screen and (max-width: 1200px) {
    .vid-container {
        width: 100%;
    }
}

@media only screen and (max-width: 1024px) {
    .tab-content-container {
        min-height: 50vh;
    }
}

.loading-container {
    overflow-y: hidden !important;
}

.xsmall-hpe-loader {
    width: 32px;
    height: 12px;
    margin: -3px 0 0 -10px;
    border: 4px solid #01a982;
    position: relative;
    top: 50%;
    left: 50%;
    animation: rotateLoader 1.4s infinite ease-in-out;
}

.small-loader {
    background: white;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
}

.small-hpe-loader {
    width: 64px;
    height: 16px;
    margin: -3px 0 0 -10px;
    border: 4px solid #01a982;
    position: absolute;
    top: 50%;
    left: 50%;
    animation: rotateLoader 1.4s infinite ease-in-out;
}

.loader {
    background: white;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
}

@keyframes rotateLoader {
    0% {
        transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    }

    33% {
        transform: perspective(120px) rotateX(-180deg) rotateY(0deg);
    }

    66% {
        transform: perspective(120px) rotateX(-180deg) rotateY(-180deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.psn-recommended-item a {
    text-decoration: none !important;
}

.fill{
    width: 100%;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gDAAgD;IAChD,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA,6CAA6C;AAC7C;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;AACZ;;AAEA,yBAAyB;;AAEzB;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yDAAyQ;AAC7Q;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,mCAAmC;IACnC,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,mCAAmC;IACnC,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,mCAAmC;IACnC,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,mCAAmC;IACnC,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;;CAGC;AACD;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI;QACI,yDAAyD;IAC7D;;IAEA;QACI,4DAA4D;IAChE;;IAEA;QACI,+DAA+D;IACnE;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["body {\r\n    margin: 0;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n        sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n\r\n.wrapper {\r\n    max-width: 1600px;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n}\r\n\r\n.tab.active {\r\n    font-weight: bold;\r\n}\r\n\r\n.page-link {\r\n    color: #01a982;\r\n}\r\n\r\n.page-item.active .page-link {\r\n    background-color: #01a982;\r\n    border-color: #01a982;\r\n}\r\n\r\n.video-js .vjs-overlay-background {\r\n    background-color: rgba(255, 255, 255, 0.4);\r\n    border-radius: 3px;\r\n    padding: 5px;\r\n    width: 33%;\r\n}\r\n\r\n.vjs-subs-caps-button .vjs-menu li {\r\n    min-width: 7em;\r\n    width: auto\r\n}\r\n\r\n.vjs-menu {\r\n    top: 15px;\r\n    width: auto\r\n}\r\n\r\n.vjs-menu li {\r\n    min-width: 7em;\r\n    width: auto\r\n}\r\n\r\n.vjs-menu-content {\r\n    overflow-x: hidden;\r\n    height: 100px;\r\n    min-width: 7em;\r\n}\r\n\r\n#qa-website-inject {\r\n    max-width: 355px;\r\n    margin: 0 0 0 15px;\r\n}\r\n\r\n#qa-website-inject-title {\r\n    display: none;\r\n}\r\n\r\n#qa-website-inject-items {\r\n    display: block;\r\n    padding: 15px 0 0 0;\r\n}\r\n\r\nimg[id^=qa-website-inject-item-image] {\r\n    width: 60px;\r\n    height: 40px;\r\n}\r\n\r\nlb-inpage-item {\r\n    display: block;\r\n    padding-left: 20px;\r\n}\r\n\r\ndiv[id^=qa-website-inject-item-title] {\r\n    position: relative;\r\n    bottom: 40px;\r\n    left: 70px;\r\n    width: 240px !important;\r\n    margin: 0 0 0 15px !important;\r\n    color: rgb(51, 51, 51);\r\n    line-height: 20px;\r\n    font-size: 14px;\r\n}\r\n\r\n.psn-recommendations-bottom.psn-static-mode .psn-static-title,\r\n.psn-scroll-right,\r\n.psn-scroll-left {\r\n    display: none !important;\r\n}\r\n\r\n.psn-recommendations-bottom .psn-item-carousel {\r\n    display: block !important;\r\n    width: 100%;\r\n}\r\n\r\n.psn-recommendations-bottom .psn-recommended-item {\r\n    display: block !important;\r\n    margin: 10px 10px !important;\r\n    width: 96% !important;\r\n}\r\n\r\n.psn-recommendations-bottom .psn-recommended-item .psn-item-image {\r\n    height: 6em !important;\r\n}\r\n\r\n.psn-recommendations-bottom .psn-recommended-item .psn-item-data .psn-item-title span,\r\n.psn-recommendations-bottom .psn-recommended-item .psn-item-data .psn-item-description span.psn-long {\r\n    font-size: 0.80rem !important;\r\n}\r\n\r\n.psn-recommendations-bottom .psn-recommended-item .psn-item-data .psn-item-title {\r\n    max-height: 5.00em !important;\r\n}\r\n\r\n.psn-item-arrow {\r\n    display: none !important;\r\n}\r\n\r\n.pf-item {\r\n    height: 70px;\r\n    padding: 10px;\r\n    border: 1px solid rgba(0, 0, 0, .125);\r\n    border-radius: .25rem;\r\n    margin: 10px;\r\n}\r\n\r\n.pf-item a {\r\n    text-decoration: none;\r\n}\r\n\r\n.pf-item:hover {\r\n    background: #EDEDED;\r\n}\r\n\r\n.productLink {\r\n    font-size: 108%;\r\n    padding: 10px 10px 10px 0;\r\n    display: block;\r\n    height: 60px;\r\n}\r\n\r\n.productLink:hover {\r\n    background: #EDEDED;\r\n}\r\n\r\n.productLink a {\r\n    padding: 0 10px 0 10px;\r\n    display: block;\r\n}\r\n\r\n.productLink span {\r\n    position: relative;\r\n    bottom: 60px;\r\n    left: 80px;\r\n    display: block;\r\n}\r\n\r\n.nav-link {\r\n    display: block;\r\n    padding: 0.5rem 0.5rem;\r\n    color: black;\r\n}\r\n\r\n.nav-link:hover {\r\n    color: black;\r\n    font-weight: bold;\r\n}\r\n\r\n.nav-tabs .nav-link.active {\r\n    color: #01a982;\r\n    font-weight: bold;\r\n}\r\n\r\n.card:hover {\r\n    background: #EDEDED;\r\n}\r\n\r\n.video-max {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.check-box {\r\n    font-size: 16px;\r\n}\r\n\r\n.radio-button {\r\n    font-size: 14px;\r\n}\r\n\r\n.vid-container {\r\n    width: 67vw;\r\n    padding-top: 56.25%;\r\n    /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */\r\n    position: relative;\r\n    /* If you want text inside of it */\r\n}\r\n\r\n.bc-player-default_default {\r\n    width: auto;\r\n    height: 100%;\r\n}\r\n\r\n.brightcove-react-player-loader {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.tab-box {\r\n    height: 27.5vw !important;\r\n    border-bottom: solid 1px lightgray;\r\n}\r\n\r\n.tab-content-container {\r\n    height: 33vw !important;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    border-right: solid 1px lightgray;\r\n    border-left: solid 1px lightgray;\r\n    border-bottom: solid 1px lightgray;\r\n}\r\n\r\n/* If you want text inside of the container */\r\n.vid-player {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n}\r\n\r\n/* Set the border color */\r\n\r\n.custom-toggler.navbar-toggler {\r\n    border-color: #01a982;\r\n    font-size: 0.75rem;\r\n    padding: 0.15rem 0.15rem\r\n}\r\n\r\n.custom-toggler .navbar-toggler-icon {\r\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(1, 169, 130, 0.8)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\r\n}\r\n\r\n.navbar {\r\n    padding: 0 1rem;\r\n}\r\n\r\n.video-js {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.duration {\r\n    width: 2.5rem;\r\n    height: .75rem;\r\n    position: relative;\r\n    bottom: 0.75rem;\r\n    left: 0.1rem;\r\n    z-index: 1;\r\n    background: #666666;\r\n    -webkit-border-top-left-radius: 3px;\r\n    -webkit-border-bottom-left-radius: 3px;\r\n    -moz-border-radius-topleft: 3px;\r\n    -moz-border-radius-bottomleft: 3px;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\n.vcard-duration {\r\n    width: 2.5rem;\r\n    height: .75rem;\r\n    position: relative;\r\n    top: -1rem;\r\n    right: 0rem;\r\n    z-index: 1;\r\n    background: #666666;\r\n    -webkit-border-top-left-radius: 3px;\r\n    -webkit-border-bottom-left-radius: 3px;\r\n    -moz-border-radius-topleft: 3px;\r\n    -moz-border-radius-bottomleft: 3px;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\n.timeCode {\r\n    font-size: 9px;\r\n    color: #fff;\r\n    position: relative;\r\n    bottom: 0.55rem;\r\n    left: 0.55rem;\r\n}\r\n\r\n.podcast {\r\n    width: 2.5rem;\r\n    height: .75rem;\r\n    position: relative;\r\n    top: -3.4rem;\r\n    left: 0.1rem;\r\n    z-index: 1;\r\n    background: #01a982;\r\n    -webkit-border-top-left-radius: 3px;\r\n    -webkit-border-bottom-left-radius: 3px;\r\n    -moz-border-radius-topleft: 3px;\r\n    -moz-border-radius-bottomleft: 3px;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\n.vcard-podcast {\r\n    width: 2.5rem;\r\n    height: .75rem;\r\n    position: relative;\r\n    top: -5.8rem;\r\n    right: 0rem;\r\n    z-index: 1;\r\n    background: #01a982;\r\n    -webkit-border-top-left-radius: 3px;\r\n    -webkit-border-bottom-left-radius: 3px;\r\n    -moz-border-radius-topleft: 3px;\r\n    -moz-border-radius-bottomleft: 3px;\r\n    border-top-left-radius: 3px;\r\n    border-bottom-left-radius: 3px;\r\n}\r\n\r\n.podcast-label {\r\n    font-size: 9px;\r\n    color: #fff;\r\n    position: relative;\r\n    bottom: 0.55rem;\r\n    right: -0.45rem;\r\n}\r\n\r\n.search-tab {\r\n    background-color: #01a982 !important;\r\n    color: #FFFFFF !important;\r\n}\r\n\r\n/*#root {\r\n    height: 100vh;\r\n}\r\n*/\r\n@media only screen and (max-width: 1200px) {\r\n    .vid-container {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    .tab-content-container {\r\n        min-height: 50vh;\r\n    }\r\n}\r\n\r\n.loading-container {\r\n    overflow-y: hidden !important;\r\n}\r\n\r\n.xsmall-hpe-loader {\r\n    width: 32px;\r\n    height: 12px;\r\n    margin: -3px 0 0 -10px;\r\n    border: 4px solid #01a982;\r\n    position: relative;\r\n    top: 50%;\r\n    left: 50%;\r\n    animation: rotateLoader 1.4s infinite ease-in-out;\r\n}\r\n\r\n.small-loader {\r\n    background: white;\r\n    position: relative;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    display: block;\r\n}\r\n\r\n.small-hpe-loader {\r\n    width: 64px;\r\n    height: 16px;\r\n    margin: -3px 0 0 -10px;\r\n    border: 4px solid #01a982;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    animation: rotateLoader 1.4s infinite ease-in-out;\r\n}\r\n\r\n.loader {\r\n    background: white;\r\n    position: relative;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    display: block;\r\n}\r\n\r\n@keyframes rotateLoader {\r\n    0% {\r\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\r\n    }\r\n\r\n    33% {\r\n        transform: perspective(120px) rotateX(-180deg) rotateY(0deg);\r\n    }\r\n\r\n    66% {\r\n        transform: perspective(120px) rotateX(-180deg) rotateY(-180deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.psn-recommended-item a {\r\n    text-decoration: none !important;\r\n}\r\n\r\n.fill{\r\n    width: 100%;\r\n    height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
